import validate from "/home/vsts/work/1/s/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import datadog_45rum_45global from "/home/vsts/work/1/s/web/src/middleware/datadog-rum.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/web/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  datadog_45rum_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}